module.exports = __webpack_public_path__ + "media/src/images/site-top/icon-fukui-md-d0b0a97f934affeb4f8fb215b898525a.png";